module.exports = __webpack_public_path__ + "static/img/blockSize.3100e505.png";